import React from 'react';
import { Flex, ProviderConsumer, Skeleton } from '@fluentui/react-northstar';

export const CatalogPageSkeleton = () => (
  <div className={`flex py-4`}>
    <Flex column className="mt-3 gap-2 w-full">
      <CatalogItemSkeleton />
      <CatalogItemSkeleton />
      <CatalogItemSkeleton />
    </Flex>
  </div>
);

const CatalogItemSkeleton = () => (
  <ProviderConsumer render={globalTheme => (
    <div className={`p-4`} style={{ backgroundColor: globalTheme.siteVariables.colorScheme.default.background }}>
      <Skeleton animation="wave">
        <Flex gap="gap.small" vAlign="center" className="w-full">
          <Skeleton.Shape width="40px" height="40px" />
          <Flex column className='w-full'>
            <Skeleton.Shape width="50%" height="20px" />
            <Skeleton.Shape width="100%" height="20px" />
          </Flex>
        </Flex>
      </Skeleton>
    </div>
  )} />
);
